(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Hero: cross-fade slides with dot navigation */
  function initHero(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 1;
    const slides = $$('.wd-slide', el);
    const dots = $$('.wd-nok button', el);
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      slides[i].classList.remove('on'); dots[i]?.classList.remove('on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('on'); dots[i]?.classList.add('on');
    };
    const sec = parseInt(el.dataset.autoplay, 10) || 0;
    const auto = () => { clearInterval(timer); if (sec) timer = setInterval(() => go(i + 1), sec * 1000); };
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); auto(); }));
    auto();
  }

  /* Product gallery + night mode ("Turn off the lights"): slides with data-ov get a lit-candle overlay */
  function initGallery(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 1;
    const main = el.querySelector('[data-wd-main]');
    const slides = $$('[data-wd-slide]', el);
    const thumbs = $$('[data-wd-thumb]', el);
    const product = el.closest('[data-product]') || document;
    const switches = $$('[data-wd-night]', product);
    const root = document.documentElement;
    const night = () => root.classList.contains('wd-gece');
    const current = () => slides.find((s) => s.classList.contains('on')) || slides[0];
    const paint = () => {
      const s = current();
      const ov = night() && s && s.dataset.ov;
      if (ov) main.style.setProperty('--ov', `url("${ov}")`);
      main.classList.toggle('karan', !!ov);
    };
    const show = (id) => {
      if (!slides.some((s) => s.dataset.wdSlide === String(id))) return;
      slides.forEach((s) => s.classList.toggle('on', s.dataset.wdSlide === String(id)));
      thumbs.forEach((t) => t.classList.toggle('on', t.dataset.wdThumb === String(id)));
      const act = thumbs.find((t) => t.dataset.wdThumb === String(id));
      if (act && strip) strip.scrollTo({ left: act.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + act.clientWidth / 2 });
      paint();
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.wdThumb)));
    const strip = el.querySelector('[data-wd-strip]');
    const steps = $$('[data-wd-step]', el);
    const edge = () => { if (!strip) return; const max = strip.scrollWidth - strip.clientWidth - 2;
      steps.forEach((b) => { b.disabled = b.dataset.wdStep < 0 ? strip.scrollLeft <= 2 : strip.scrollLeft >= max; b.hidden = max <= 0; }); };
    steps.forEach((b) => b.addEventListener('click', () => strip.scrollBy({ left: b.dataset.wdStep * strip.clientWidth * 0.8 })));
    strip?.addEventListener('scroll', edge, { passive: true });
    edge();
    product.addEventListener('wd:variant', (e) => { const m = e.detail && e.detail.featured_media; if (m) show(m.id); });
    const label = (on) => switches.forEach((b) => {
      b.setAttribute('aria-pressed', on);
      $$('[data-on]', b).forEach((x) => { x.textContent = on ? x.dataset.on : x.dataset.off; });
    });
    switches.forEach((b) => b.addEventListener('click', () => {
      const on = root.classList.toggle('wd-gece');
      if (on && !current().dataset.ov) {
        const lit = slides.find((s) => s.dataset.ov);
        if (lit) show(lit.dataset.wdSlide);
      }
      label(on);
      paint();
      if (on && window.innerWidth < 850) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    paint();
  }

  /* Candle on product cards: tap toggles on touch devices */
  document.addEventListener('click', (e) => {
    const m = e.target.closest('.wd-u__im.wd-mum');
    if (!m || window.matchMedia('(hover:hover)').matches) return;
    if (!m.classList.contains('karan')) { e.preventDefault(); m.classList.add('karan'); }
  });

  const init = (scope = document) => {
    $$('[data-wd-hero]', scope).forEach(initHero);
    $$('[data-wd-gallery]', scope).forEach(initGallery);
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Rotating announcement bar */
document.querySelectorAll('[data-wd-duyuru]').forEach(function (bar) {
  var items = bar.querySelectorAll('.wd-duyuru__m');
  if (items.length < 2) return;
  var i = 0, ms = (parseInt(bar.dataset.sec, 10) || 4) * 1000, timer;
  function next() {
    var cur = items[i];
    i = (i + 1) % items.length;
    cur.classList.remove('is-on');
    cur.classList.add('is-out');
    items[i].classList.remove('is-out');
    items[i].classList.add('is-on');
    setTimeout(function () { cur.classList.remove('is-out'); }, 600);
  }
  function start() { stop(); timer = setInterval(next, ms); }
  function stop() { clearInterval(timer); }
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  start();
});

/* Product detail tabs + dated delivery timeline */
document.querySelectorAll('[data-wd-tabs]').forEach(function (box) {
  var tabs = box.querySelectorAll('[data-tab]');
  var panels = box.querySelectorAll('[data-panel]');
  if (tabs.length && !box.querySelector('[data-tab].on')) tabs[0].classList.add('on');
  if (panels.length && !box.querySelector('[data-panel].on')) panels[0].classList.add('on');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.toggle('on', x === t); x.setAttribute('aria-selected', x === t); });
      panels.forEach(function (p) { p.classList.toggle('on', p.dataset.panel === t.dataset.tab); });
    });
  });
  var lang = document.documentElement.lang || 'tr';
  function plus(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }); }
  box.querySelectorAll('[data-d]').forEach(function (s) {
    var r = s.dataset.d.split('-');
    if (r.length === 2) s.textContent = fmt(plus(+r[0])) + ' – ' + fmt(plus(+r[1]));
  });
});

/* How it's made: journey — autoplay while visible, click/arrows/swipe, pause on hover */
document.querySelectorAll('[data-wd-journey]').forEach(function (box) {
  var dots = box.querySelectorAll('[data-step]');
  var pics = box.querySelectorAll('.wd-yol2__f');
  var texts = box.querySelectorAll('.wd-yol2__m');
  var now = box.querySelector('[data-now]');
  var map = box.querySelector('.wd-yol2__harita');
  var n = dots.length, i = 0, timer = null, visible = false, hover = false;
  var ms = (parseInt(box.dataset.sec, 10) || 6) * 1000;
  box.style.setProperty('--sure', ms / 1000 + 's');
  function go(k) {
    i = (k + n) % n;
    dots.forEach(function (d, j) { d.classList.toggle('on', j === i); d.classList.toggle('gecti', j < i); });
    pics.forEach(function (p, j) { p.classList.toggle('on', j === i); });
    texts.forEach(function (t, j) { t.classList.toggle('on', j === i); });
    if (now) now.textContent = i + 1;
    var d = dots[i];
    if (map && map.scrollWidth > map.clientWidth) map.scrollTo({ left: d.offsetLeft - map.clientWidth / 2 + d.clientWidth / 2, behavior: 'smooth' });
    restart();
  }
  function restart() {
    clearTimeout(timer);
    var run = visible && !hover;
    box.classList.toggle('durdu', !run);
    if (run) {
      var on = dots[i].querySelector('.wd-yol2__dolum');
      if (on) { on.style.animation = 'none'; void on.offsetWidth; on.style.animation = ''; }
      timer = setTimeout(function () { go(i + 1); }, ms);
    }
  }
  dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
  box.querySelectorAll('[data-go]').forEach(function (b) { b.addEventListener('click', function () { go(i + (+b.dataset.go)); }); });
  var sahne = box.querySelector('.wd-yol2__sahne');
  sahne.addEventListener('mouseenter', function () { hover = true; restart(); });
  sahne.addEventListener('mouseleave', function () { hover = false; restart(); });
  var x0 = null, sw = box.querySelector('[data-wd-swipe]');
  sw.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  sw.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; restart(); }, { threshold: 0.35 }).observe(box);
  } else { visible = true; restart(); }
});

/* Cart page: qty steppers update the cart; gift wrap reveals the note and saves it */
(function () {
  var form = document.getElementById('WdCart');
  if (!form) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var upd = form.querySelector('[data-wd-update]');
  var t;
  function save() { clearTimeout(t); t = setTimeout(function () { if (form.requestSubmit) form.requestSubmit(upd); else upd.click(); }, 450); }
  function post(body) { return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); }
  form.querySelectorAll('[data-wd-qty]').forEach(function (q) {
    var inp = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { inp.value = Math.max(0, (+inp.value || 0) + (+b.dataset.step)); save(); });
    });
    inp.addEventListener('change', save);
  });
  var g = form.querySelector('[data-wd-gift]');
  if (!g) return;
  var cb = g.querySelector('input[type=checkbox]');
  var note = g.querySelector('textarea');
  cb.addEventListener('change', function () {
    g.classList.toggle('acik', cb.checked);
    post({ attributes: { 'Hediye paketi': cb.checked ? 'Evet' : 'Hayır' } });
    if (cb.checked) note.focus();
  });
  note.addEventListener('change', function () { post({ note: note.value }); });
})();
